import {
  ADD_GROUPROUTE,
  GET_GROUPROUTEALL,
  GET_GROUPROUTE_DATA,
} from '../types'

const INITIAL_STATE = {
  addGrouproute: [],
  getGroupConfig: [],
  getAllGroupRoute: [],

}

const grouprouteReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_GROUPROUTE_DATA:
      return {
        ...state,
        getGroupConfig: payload.data,
      }
    case GET_GROUPROUTEALL:
      return {
        ...state,
        getAllGroupRoute: payload.data,
      }
    case ADD_GROUPROUTE:
      return {
        ...state,
        addGrouproute: payload.data,
      }
    default:
      return state
  }
}

export default grouprouteReducer
